import { render, staticRenderFns } from "./LogoutForm.vue?vue&type=template&id=0ab48572&"
import script from "./LogoutForm.vue?vue&type=script&lang=js&"
export * from "./LogoutForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports